import React, { useState, useRef, useEffect } from "react";
import { appImages } from "../../../assets";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
const MoodSelector = ({ formik }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [textInput, setTextInput] = useState("");
    const canvasRef = useRef(null);
    const { t } = useTranslation()
    const images = [
        appImages?.happy,
        appImages?.sick,
        appImages?.emotional,
        appImages?.arms,
        appImages?.depressed,
        appImages?.scared,
    ];
    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            // Set canvas width dynamically based on the parent container
            const resizeCanvas = () => {
                const parentWidth = canvas.parentElement.clientWidth;
                canvas.width = parentWidth > 510 ? 510 : parentWidth; // Max width 510, otherwise responsive
                canvas.height = 100; // Keeping height fixed
            };

            resizeCanvas();
            window.addEventListener("resize", resizeCanvas);

            return () => window.removeEventListener("resize", resizeCanvas);
        }
    }, []);
    const mood_cards = [
        { img: appImages.happy, id: 1 },
        { img: appImages.sick, id: 2 },
        { img: appImages.emotional, id: 3 },
        { img: appImages.arms, id: 4 },
        { img: appImages.depressed, id: 5 },
        { img: appImages.scared, id: 6 },
    ];

    useEffect(() => {
        if (formik.values.moodCard) {
            setSelectedImage(mood_cards.find((card) => card.id === formik.values.moodCard)?.id || null);
        }
        if (formik.values.drawing) {
            const canvas = canvasRef.current;
            const context = canvas.getContext("2d");
            const img = new Image();
            img.onload = () => {
                context.drawImage(img, 0, 0);
            };
            img.src = formik.values.drawing;
        }
    }, [formik.values.moodCard, formik.values.drawing]);

    const handleImageSelect = (index) => {
        setSelectedImage(mood_cards[index].id);
        formik.setFieldValue('moodCard', mood_cards[index].id);
    };


    const handleCanvasDraw = (event) => {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        const rect = canvas.getBoundingClientRect();

        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        context.fillStyle = "black";
        context.beginPath();
        context.arc(x, y, 5, 0, Math.PI * 2, true);
        context.fill();
    };

    const handleSaveCanvas = () => {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        // Get pixel data
        const pixelBuffer = new Uint32Array(
            context.getImageData(0, 0, canvas.width, canvas.height).data.buffer
        );

        const isEmpty = !pixelBuffer.some(color => color !== 0);

        if (isEmpty) {
            toast.error(t(`drawing_is_empty`) || "Drawing is empty");
            return;
        }

        const imageData = canvas.toDataURL("image/png");
        formik.setFieldValue("drawing", imageData);
        toast.success(t(`save_drawing`));
    };
    const handleClearCanvas = () => {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        toast.success(t(`clear_drawing`));
    };


    return (
        <div className="flex flex-col items-center md:p-4 max-h-[65vh] overflow-y-auto">
            {/* Image Selection */}
            <h2 className="text-[13px] md:text-center text-left text-white font-[500] mb-2">
                {t(`l5-6-heading1`)}
            </h2>
            <div className="grid grid-cols-3 gap-4 mb-8">
                {mood_cards.map((src, index) => (
                    <img
                        key={index}
                        src={src?.img}
                        alt={`Mood ${index + 1}`}
                        className={`w-24 h-12 object-cover cursor-pointer rounded-lg ${selectedImage === src.id
                            ? "ring-4 ring-[#F9DCD4]" // Highlight selected image
                            : "hover:ring-4 hover:ring-gray-300"
                            }`}
                        onClick={() => handleImageSelect(index)}
                    />
                ))}
            </div>

            {formik.errors.moodCard && (
                <p className="text-red-500 text-xs mb-1 w-full text-left">
                    {formik.errors.moodCard}
                </p>
            )}

            {/* Drawing and Writing Section */}
            <h3 className="text-[13px] md:text-center text-left text-white font-[500] mb-2">
                {t(`l5-6-heading2`)}
            </h3>
            <div className="flex flex-col md:flex-row gap-4 w-full max-w-4xl">
                {/* Drawing Canvas */}
                <div className="bg-[#D9D9D9] p-4 rounded-none w-full ">
                    {/* <h4 className="text-md font-medium mb-2"> {t(`l5-6-heading3`)}</h4> */}
                    <div className="flex justify-start gap-2 items-center">
                        <button className=" bg-black text-white py-1 px-2 " onClick={handleSaveCanvas}>  {t(`save`)} </button>
                        <button className=" bg-black text-white py-1 px-2 " onClick={handleClearCanvas}> {t(`clear`)} </button>
                    </div>

                    <div className="mt-2">
                        <canvas
                            ref={canvasRef}
                            className="border border-gray-400 rounded-none cursor-crosshair"
                            width="510"
                            height="100"
                            onMouseDown={(e) => e.buttons === 1 && handleCanvasDraw(e)}
                            onMouseMove={(e) => e.buttons === 1 && handleCanvasDraw(e)}
                        ></canvas>
                    </div>
                </div>
            </div>
            {formik.errors.drawing && (
                <p className="text-red-500 text-xs mb-1 w-full text-left">
                    {formik.errors.drawing}
                </p>
            )}
        </div>
    );
};

export default MoodSelector;
